<template>
  <div class="table-container">
    <b-overlay center :show="isLoading" rounded="sm">
      <div v-if="!isLoading">
        <div v-if="ok">
          <validation-observer
            ref="observer"
            v-slot="{ invalid, handleSubmit }"
          >
            <b-form @submit.prevent="">
              <div class="form-card-wrapper">
                <b-card header-tag="header">
                  <template #header>
                    <b>Dati Generali</b>
                  </template>
                  <b-card-text>
                    <b-row>
                      <div class="form-group">
                        <base-input
                          vid="code"
                          :name="beForm[rep].code.label"
                          :label="getDictionary('code', rep)"
                          v-model="form[rep].code"
                          :rules="getRules('code')"
                          maxlength="4"
                        />
                      </div>
                      <div class="form-group">
                        <base-input
                          vid="title"
                          :name="beForm[rep].title.label"
                          :label="getDictionary('title', rep)"
                          v-model="form[rep].title"
                          :rules="getRules('title')"
                        />
                      </div>
                      <div class="form-group">
                        <base-select
                          vid="insurer_id"
                          :name="beForm[rep].insurer_id.label"
                          :label="getDictionary('insurer')"
                          v-model="form[rep].insurer_id"
                          :options="companies"
                          :rules="getRules('insurer_id')"
                        />
                      </div>
                      <div class="form-group">
                        <base-select
                          vid="is_expired"
                          :name="beForm[rep].is_expired.label"
                          :label="getDictionary('is_expired', rep)"
                          v-model="form[rep].is_expired"
                          :options="beForm[rep].is_expired.options"
                          :rules="getRules('is_expired')"
                        />
                      </div>
                    </b-row>
                  </b-card-text>
                </b-card>
              </div>

              <div class="form-actions form-actions--sticky">
                <div class="inner-wrapper">
                  <div>
      <span
        :title="`${
          invalid
            ? 'Compila correttamente i campi per poter salvare'
            : 'Invia il form'
        }`"
      >
        <b-button
          @click="handleSubmit(onSubmit)"
          type="button"
          :disabled="invalid"
          variant="lisaweb"
          size="sm"
          :title="`${
            invalid
              ? 'Compila correttamente i campi per poter salvare'
              : 'Invia il form'
          }`"
        >
          Salva
        </b-button>
      </span>
                    <b-button
                      @click="resetForm()"
                      class="btn--transparent btn-reset"
                      type="button"
                      title="Pulisci tutti i campi e compila il form nuovamente"
                    >Reset
                    </b-button
                    >
                  </div>
                  <div>
                    <b-button
                      @click="goBack()"
                      class="btn--transparent"
                      type="button"
                      title="Torna alla pagina precedente"
                    >
                      <b-icon-chevron-double-left
                        font-scale="0.9"
                      ></b-icon-chevron-double-left
                      >
                      Torna indietro
                    </b-button
                    >
                  </div>
                </div>
              </div>
            </b-form>
          </validation-observer>
        </div>
        <div v-else>
          {{ errorMessage }}
        </div>
      </div>

      <template #overlay>
        <div class="text-center">
          <div class="custom-loader"></div>
          <p class="loading-text">Operazione in corso...</p>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
import ShortcutMixin from "@/mixins/ShortcutMixin";
import FormMixin from "@/mixins/FormMixin";
import BaseInput from "@/components/form/BaseInput";
import BaseSelect from "@/components/form/BaseSelect";
import {mapGetters} from "vuex";

export default {
  mixins: [FormMixin, ShortcutMixin],
  data() {
    return {
      repository: "mandate_code",
      companies: [],
      form: {
        mandate_code: {
          code: null,
          title: null,
          insurer_id: null,
          is_expired: null,
        },
      },
    };
  },
  components: {
    BaseInput,
    BaseSelect,
  },
  methods: {
    goBack() {
      if (this.returnUrl) {
        switch (this.returnUrl) {
          case "profile-mandate-codes-create":
            this.$router.push({
              name: "mandate_codes.create",
            });
            break;
          default:
            console.log(
              "No returnUrl set matched! Fallback to default back behavior."
            );
            this.$router.back();
            break;
        }
      } else {
        this.$router.back();
      }
    },
    onSubmit() {
      this.isLoading = true;
      this.store(this.repository)
        .then(() => {
          this.$store.dispatch("auth/mandate_codes");
          this.$showSnackbar({
            preset: "success",
            text: `Azione Completata: Mandato Creato`,
          });
          this.shortcut(
            "module.PROF",
            null,
            "#MandateCodes",
            "filterMandateCode"
          );
          this.isLoading = false;
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
          this.isLoading = false;
        });
    },
    ...mapGetters("auth", {
      getInsurers: "insurers",
    }),
  },
  created() {
    this.isLoading = true;
    this.fetchCreateForm(this.repository).then(() => {
      this.companies = this.getInsurers();
      this.isLoading = false;
    });
  },
  computed: {
    rep() {
      return this.repository;
    },
    prdct() {
      return this.products;
    },
  },
};
</script>
